import { useState } from "react";
import { ExternalLink, Info, X } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const KEY = "fmo_stripe_info_dismissed";

// Informational only (never blocks an upload): sell through Stripe, not Google Play Billing / RevenueCat.
export const StripeInfo = ({ dismissible = false, testId = "stripe-info" }) => {
  const { t } = useI18n();
  const [hidden, setHidden] = useState(() => dismissible && localStorage.getItem(KEY) === "1");
  if (hidden) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <aside className="fade-up relative flex min-w-0 gap-3 rounded-2xl border border-sky-400/30 bg-sky-950/40 p-4 pe-10 text-start" role="note" data-testid={testId}>
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-sky-300" aria-hidden="true" />
      <div className="min-w-0 space-y-1.5">
        <p className="break-words text-sm font-bold text-white" data-testid={`${testId}-title`}>{t("stripeInfo.title")}</p>
        <p className="break-words text-xs leading-relaxed text-sky-100/90 sm:text-sm" data-testid={`${testId}-body`}>{t("stripeInfo.body")}</p>
        <a href="https://stripe.com/fr" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center gap-1 text-xs font-semibold text-sky-300 underline-offset-2 hover:underline sm:min-h-0" data-testid={`${testId}-link`}>
          {t("stripeInfo.link")} <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
      {dismissible && (
        <button type="button" onClick={close} aria-label={t("stripeInfo.close")} className="absolute end-1 top-1 inline-flex h-11 w-11 items-center justify-center rounded-full text-sky-200 transition-colors hover:bg-white/10" data-testid={`${testId}-close`}>
          <X className="h-4 w-4" />
        </button>
      )}
    </aside>
  );
};
